<div class="geographic-filter">
    <mc-lasso-tool-ng id="mcLassoTool" #lassoTool></mc-lasso-tool-ng>
    <div class="system-boundary-or-draw-on-map">
        <div class="filter-by">
            <span>Boundary Options:</span>
        </div>
        <div class="radio-group-container">
            <fieldset class="radio-group">
                <input class="radio-group-input" type="radio" id="radio-system" [disabled]="disableField" [ngModel]="boundarySource"
                       value="system" />
                <label class="radio-group-label" for="system" (click)="disableField?null:setUseSystemBoundary()">
                    System
                    Boundary
                </label>
                <input class="radio-group-input" type="radio" id="radio-draw" [disabled]="disableField" [ngModel]="boundarySource" value="draw" />
                <label class="radio-group-label" for="draw" (click)="disableField?null:setDrawBoundaryOnMap()">
                    Draw Boundary on Map
                </label>
                <!--
                Switch to this if the drawing needs to be disabled if no layer is loaded
                <input class="radio-group-input" type="radio" id="radio-draw" [ngModel]="boundarySource" value="draw" [disabled]="!this.esriLayers || !this.esriLayers.length" />
                <label class="radio-group-label" [ngClass]="{'btn-disabled': !this.esriLayers || !this.esriLayers.length}" [title]="!this.esriLayers || !this.esriLayers.length ? 'Layer must be loaded to use boundary drawing' : ''" for="draw" (click)="setDrawBoundaryOnMap()">
                    Draw Boundary on Map
                </label>-->
            </fieldset>
        </div>
    </div>
    <div *ngIf="workingGuid && existingGuidFromLayers" class="directions contains-filter">
        Layer currently contains a geographic filter.
    </div>
    <div class="system-boundary" *ngIf="boundarySource === 'system'">
        <div *ngIf="!existingGuidFromLayers">
            <div class="boundary-type-select select-container">
                <span>Select a boundary:</span>
                <select class="select" [disabled]="disableField" [(ngModel)]="selectedLayerId" name="selectedLayerId" (change)="layerIdChanged()">
                    <option value="0">Select a Feature Type...</option>
                    <option *ngFor="let boundaryType of boundaryTypes" [ngValue]="boundaryType.layerId">
                        {{ boundaryType.displayText }}
                    </option>
                </select>
            </div>
            <div class="county-select select-container" *ngIf="showCountySelect && selectedLayerId > 0">
                <span>Select a county first:</span>
                <select class="select" [(ngModel)]="selectedCountyCode" name="selectedCountyCode"
                        (change)="selectedCountyChange()">
                    <option *ngFor="let county of counties" [ngValue]="county.countyCode">
                        {{ county.countyCode }}-{{ county.name }}
                    </option>
                </select>
            </div>
            <div class="feature-select select-container" *ngIf="showFeatureSelect && selectedLayerId > 0">
                <span>Select a feature:</span>
                <ng-container>
                    <select multiple class="select" [(ngModel)]="selectedFeatures" name="selectedFeature"
                            (change)="selectedFeaturesChanged()">
                        <option *ngFor="let feature of features" [ngValue]="feature">
                            {{ feature.displayText }}
                        </option>
                    </select>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="draw-boundary-on-map" *ngIf="boundarySource === 'draw'">
        <div *ngIf="!workingGuid" class="directions ready">Draw a polygon on the map to filter this layer.</div>
        <div *ngIf="workingGuid && !existingGuidFromLayers" class="directions">
            A working geographic filter is ready to apply.
        </div>
    </div>
    <div class="button-container">
        <button class="btn apply-filter" *ngIf="boundaryFeaturesAreSelected && !spatialQuerySelection"
                (click)="applySystemBoundaryFilter()">
            Apply Boundary Filter
        </button>
        <button class="btn apply-filter" *ngIf="showApplyButton"
                (click)="applyFilterChangeToLayer()">
            Apply Working Filter
        </button>
        <button class="btn apply-filter" *ngIf="existingGuidFromLayers && !spatialQuerySelection" (click)="removeGeographicFilter()">
            Remove Geographic Filter
        </button>
        <button class="btn remove" *ngIf="!existingGuidFromLayers && workingGuid && !spatialQuerySelection"
                (click)="clearExistingSpatialFilter()">
            Clear Working Filter
        </button>
        <button class="btn btn-clear cancel" (click)="cancel()" *ngIf="(spatialQuerySelection && boundarySource === 'draw') || !spatialQuerySelection">
            Cancel
        </button>
    </div>
</div>
